import React, { useEffect, useState } from 'react';
import FilterGroup from './FilterGroup';

const Filters = ({
  currentData,
  currentFilters,
  query,
  handleFilter,
  handleSlider,
  reset,
  scrollerBack,
  count,
}) => {
  const [data, setData] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [isActive, setActive] = useState(false);

  useEffect(() => {
    const setFilterData = async () => {
      // Get array of filters.
      const currentDataArr = Object.values(currentData);
      const master = {};
      currentDataArr.forEach((el) => {
        const thisNodeValues = el.value;
        const { active } = el;
        // Foreach nodes values.
        Object.keys(thisNodeValues).forEach((key) => {
          const filterIds = thisNodeValues[key];
          let termObject;
          let termObjectValue;
          filterIds.forEach((x) => {
            // If type term/node.
            if (currentFilters[key].type !== 'number') {
              termObject = currentFilters[key];
              termObjectValue = currentFilters[key].value[x];
              // We're ONLY dealing with the currently clicked filter. What about the rest?
              // if (currentFilters[key].value[x].active !== 'active') {
              //   currentFilters[key].value[x].active = 'active';
              // }

              // We dealing with MASTER, not current filters.
              // If this node is active, set its values to active.
              if (el.active || termObjectValue.active === true) {
                termObjectValue.active = true;
              } else {
                termObjectValue.active = false;
              }

              if (termObject) {
                if (
                  master[key] !== undefined &&
                  Array.isArray(master[key].value)
                ) {
                  // Check for existing values first.
                  const existingId = master[key].value.some(
                    (term) => term.id === termObjectValue.id
                  );

                  if (!existingId) {
                    master[key].value.push(termObjectValue);
                  }
                } else {
                  master[key] = {
                    field: termObject.field,
                    label: termObject.label,
                    type: termObject.type,
                    weight: termObject.weight,
                    value: [termObjectValue],
                  };
                }
              }
            } else {
              termObject = currentFilters[key];
              const vals = thisNodeValues[key].map((val) => parseInt(val));
              if (
                master[key] !== undefined &&
                Array.isArray(master[key].value)
              ) {
                master[key].value = Array.from(
                  new Set(master[key].value.concat(vals))
                );
              } else {
                master[key] = {
                  field: termObject.field,
                  label: termObject.label,
                  type: termObject.type,
                  weight: termObject.weight,
                  value: vals,
                };
              }
            }
          });
        });
      });

      const sorted = Object.values(master).sort((a, b) => a.weight - b.weight);

      setData(sorted);
      setLoaded(true);
    };

    setFilterData();
  }, [currentData, currentFilters]);

  const toggleClose = () => {
    setActive(false);
  };

  const toggleOpen = () => {
    setActive(true);
  };

  const toggleOpenClose = (e) => {
    // React wants a keyboard listener since there is an onclick. Need to make sure it's a specific key.
    if (e.type === 'keydown' && e.code !== 'Enter') {
      return;
    }

    if (isActive) {
      setActive(false);
    } else {
      setActive(true);
    }
  };

  return (
    <div className={`filters ${isActive ? 'active' : ''}`}>
      <div
        className="filters-toggle"
        role="button"
        tabIndex="0"
        onClick={toggleOpenClose}
        onKeyDown={toggleOpenClose}
      >
        Filters
        <div
          role="button"
          tabIndex="0"
          onClick={toggleClose}
          onKeyDown={toggleClose}
          className="closer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 448 512"
          >
            <path d="M432 256C432 264.8 424.8 272 416 272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384C424.8 240 432 247.2 432 256z" />
          </svg>
        </div>
        <div
          role="button"
          tabIndex="0"
          onClick={toggleOpen}
          onKeyDown={toggleOpen}
          className="opener"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 448 512"
          >
            <path d="M432 256C432 264.8 424.8 272 416 272h-176V448c0 8.844-7.156 16.01-16 16.01S208 456.8 208 448V272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h176V64c0-8.844 7.156-15.99 16-15.99S240 55.16 240 64v176H416C424.8 240 432 247.2 432 256z" />
          </svg>
        </div>
      </div>
      {loaded &&
        data.map((value, key) => (
          <div key={key} className="filter">
            {Object.keys(data[key].value).length > 0 && (
              <FilterGroup
                label={data[key].label}
                id={data[key]}
                handleFilter={handleFilter}
                handleSlider={handleSlider}
                type={data[key].type}
                query={query}
              />
            )}
          </div>
        ))}{' '}
      <div className="filters-tools">
        <button type="button" onClick={(e) => scrollerBack()}>
          View {count} Results
        </button>
        <button
          type="button"
          className="btnReset"
          onClick={(e) => reset('clear')}
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default Filters;
